<template>
  <div>
    <table-render
      ref="tableRender"
      :config="config"
      height="45vh"
      width="80vw"
      @selection-change="e => (selection = e)"
      rowKey="orderNumber"
      :rowClassName="
        ({ row, rowIndex }) =>
          getUnqualifiedRowConfig({
            row: row,
            rowIndex: rowIndex,
            isNotUnqualified: isNotUnqualified(row)
          })
      "
    />
    <div>
      确认移除后，本订单内将会直接移除所选项目参与人。您可在项目结算管理中重新选择该用户进行支付
    </div>
    <the-footer :params="delParams" />
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import { listNoPayOrderPeopleByOrderId } from './config';
import { csoCustomerOrder } from '@/api/ajax';
import { getUnqualifiedRowConfig } from '@/methods/unqualified';

export default {
  name: 'EditPayPerson',
  cname: '修改支付人',
  props: ['row'],
  inject: ['_parent'], // 最外层父级列表，可能是按批次列表或者按项目列表

  data() {
    return {
      getUnqualifiedRowConfig,
      config: null,
      selection: []
    };
  },
  computed: {
    delParams() {
      let map = {
        1: 4,
        2: 3,
        3: 3
      };

      let threeIds = this.selection
        .filter(i => {
          return map[i['projectStructureType']] == 3;
        })
        .map(j => j.id)
        .toString();

      let fourIds = this.selection
        .filter(i => {
          return map[i['projectStructureType']] == 4;
        })
        .map(j => j.id)
        .toString();
      const { id } = this.row;
      return {
        csoCustomOrderId: id,
        threeIds,
        fourIds
      };
    }
  },
  components: {
    tableRender,
    // functional:true,
    theFooter: {
      props: {
        params: {
          type: Object,
          default: function() {
            return {};
          }
        }
      },
      render(h) {
        const vm = this;
        const close = () => this.$xrkDialog.remove();
        const del = () =>
          new Promise(async (resolve, reject) => {
            if (this.params.fourIds || this.params.threeIds) {
              await csoCustomerOrder.delNoPayOrderPeople(this.params);
              const selection = vm.$parent.selection; //移除人员勾选
              const tableData = vm.$parent.$refs.tableRender.tableData; //移除人员列表
              let needDelOrderId = ''; //需要告知订单列表勾选删除的id
              if (selection.length === tableData.length) {
                //人员全部移除了 订单列表就会少了一条数据
                //通知订单列表移除勾选的id 重新刷新列表
                needDelOrderId = vm.$parent.row.id;
              }
              // 当前列表刷新
              vm.$parent.$refs.tableRender.saveSuccess();
              this.$message({
                type: 'success',
                message: '修改成功'
              });
              // 用于通知父级更新列表等操作
              vm.$parent.$emit('confirm', {
                _ctx: vm.$parent._parent,
                needDelOrderId
              });
              resolve();
            } else {
              this.$message({
                type: 'error',
                message: '请选择需要移除人员'
              });
              reject('请选择需要移除人员');
            }
          });

        return h(
          'div',
          {
            style: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '10px 50px'
            }
          },
          [
            h(
              'el-button',
              {
                style: {
                  width: '150px'
                },
                props: { type: 'primary' },
                on: {
                  click: async () => {
                    await del();
                    // close();
                  }
                }
              },
              '确认移除'
            ),
            h(
              'el-button',
              {
                on: {
                  click: () => {
                    close();
                  }
                }
              },
              ['关闭']
            )
          ]
        );
      }
    }
  },
  methods: {
    isNotUnqualified(row) {
      return !(row.zbBlackStatus === 2);
    }
  },
  created() {
    listNoPayOrderPeopleByOrderId[0].childMenu[0].defaultQuery = {
      orderId: this.row.id
    };
    this.config = listNoPayOrderPeopleByOrderId;
  }
};
</script>
